<div class="rounded_image_container w-max">
  <img DefaultImage [src]="imageSrc" alt="" [style]="imgeStyles" referrerpolicy="no-referrer" [default]="default" />
</div>
